<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Работа с ЭСФ</h3>
      <div class="filters">
        <div class="row col-md-6">
          <div class="el-input-group">
            <label for="bin" class="form-label col-md-3"></label>
            <div class="col-md-9">
              <div class="input-group">
                <input v-if="!hasAccess(kindergartenHeadRoles)" class="form-control" type="text" placeholder="Поиск по БИН/ID счета"
                       id="bin"
                       v-model="page.filter.search"
                       style="font-style: italic;">
                <button class="btn btn-primary" type="button" @click="reloadList()">
                  Найти
                </button>
              </div>
            </div>
          </div>
        </div>

        <div class="row col-md-6">
          <div class="el-input-group">
            <label for="filterMonth" class="form-label col-md-3">
              Учетный месяц
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.month" id="filterMonth"
                      v-on:change="reloadList()"
                      class="form-select">
                <option v-for="(monthName, index) in months" :key="index" :value="index + 1">
                  {{ monthName }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="row col-md-6">
          <div class="el-input-group">
            <label for="filterYear" class="form-label col-md-3">
              Учетный год
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.year" id="filterYear"
                      v-on:change="reloadList()"
                      class="form-select">
                <option v-for="(year, index) in years" :key="index" :value="year">
                  {{ year }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div v-if="!hasAccess(kindergartenHeadRoles)" class="row col-md-6">
          <div class="el-input-group">
            <label for="status" class="form-label col-md-3">
              Статус сверки
            </label>
            <div class="col-md-9">
              <select v-model="page.filter.invoiceVerificationStatus" id="status"
                      v-on:change="reloadList()"
                      class="form-select">
                <option v-for="statusKey in Object.keys(invoiceVerificationStatus)" :key="statusKey" :value="statusKey">
                  {{ invoiceVerificationStatus[statusKey] }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div v-if="!hasAccess(kindergartenHeadRoles)" class="row col-md-6">
          <div class="el-input-group">
            <label for="status" class="form-label col-md-3">
              Населенный пункт
            </label>
            <div class="col-md-9">
              <multiselect
                  v-model="page.filter.kato"
                  :options="katoList"
                  :searchable="true"
                  :closeOnSelect="true"
                  :custom-label="formattedKatoLabel"
                  placeholder="Выберите Като"
                  :multiple="false"
                  :clear-on-select="true"
                  @select="reloadList()"
              />
            </div>
          </div>
        </div>

        <div v-if="!hasAccess(kindergartenHeadRoles)" class="row col-md-6">
          <div class="el-input-group">
            <label for="filterDate" class="form-label col-md-3">
              Дата утверждения акта
            </label>
            <div class="col-md-9">
              <input
                  type="date"
                  id="filterDate"
                  v-model="page.filter.selectedApproveDate"
                  class="form-control"
                  @change="reloadList()"
              />
            </div>
          </div>
        </div>

        <div class="row col-md-6">
          <div class="el-input-group">
            <div class="form-check">
              <input class="form-check-input" type="checkbox" id="hideAcceptedInvoices"
                     v-on:change="reloadList()"
                     v-model="page.filter.hideAcceptedInvoices"/>
              <label class="form-check-label" for="hideAcceptedInvoices">
                Скрывать успешные сверки
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
    <div class="page-content-info d-flex align-items-center justify-content-end gap-2">
      <b-button variant="success"
                v-if="!hasAccess(kindergartenHeadRoles)"
                :disabled="items.length === 0"
                @click="onClickGenerateReport()">
        Экспортировать в MS Excel
      </b-button>
      <b-button variant="success"
                :disabled="!hasAccessToDownloadInvoiceTemplate"
                @click="onClickGenerateInvoiceTemplate()">
        <span v-if="hasAccessToDownloadInvoiceTemplate">Проект ЭСФ</span>
        <span v-else>Проект ЭСФ не доступен</span>
      </b-button>
    </div>

    <div class="page-content-info d-flex align-items-center justify-content-between">
      <div>Найдено: <span>{{ totalCount }}</span></div>
    </div>

    <b-table striped hover
             :items="items"
             :fields="fields"
             responsive="sm"
             no-local-sorting
             show-sort-labels>
      <template #head(bin)="data">
        <div class="sortable-container none"
             @click="onSortChanged('bin')"
             :class="{'ascending': page.sort.bin === 'ASC', 'descending': page.sort.bin === 'DESC'}">
          БИН ДО
        </div>
      </template>
      <template #head(lmsId)="data">
        <div class="sortable-container none"
             @click="onSortChanged('lmsId')"
             :class="{'ascending': page.sort.lmsId === 'ASC', 'descending': page.sort.lmsId === 'DESC'}">
          ID LMS
        </div>
      </template>
      <template #head(numberAct)="data">
        <div class="sortable-container none"
             @click="onSortChanged('numberAct')"
             :class="{'ascending': page.sort.numberAct === 'ASC', 'descending': page.sort.numberAct === 'DESC'}">
          Номер акта
        </div>
      </template>
      <template #head(signedAmount)="data">
        <div class="sortable-container none"
             @click="onSortChanged('signedAmount')"
             :class="{'ascending': page.sort.signedAmount === 'ASC', 'descending': page.sort.signedAmount === 'DESC'}">
          Сумма подписанного расчета
        </div>
      </template>
      <template #head(approveDate)="data">
        <div class="sortable-container none"
             @click="onSortChanged('approveDate')"
             :class="{'ascending': page.sort.approveDate === 'ASC', 'descending': page.sort.approveDate === 'DESC'}">
          Дата утверждения акта
        </div>
      </template>
      <template #head(invoiceId)="data">
        <div class="sortable-container none"
             @click="onSortChanged('invoiceId')"
             :class="{'ascending': page.sort.invoiceId === 'ASC', 'descending': page.sort.invoiceId === 'DESC'}">
          ID счета
        </div>
      </template>
      <template #head(invoiceVerificationStatus)="data">
        <div class="sortable-container none"
             @click="onSortChanged('invoiceVerificationStatus')"
             :class="{'ascending': page.sort.invoiceVerificationStatus === 'ASC', 'descending': page.sort.invoiceVerificationStatus === 'DESC'}">
          Статус сверки
        </div>
      </template>
      <template #head(statusNameRu)="data">
        <div class="sortable-container none"
             @click="onSortChanged('statusNameRu')"
             :class="{'ascending': page.sort.statusNameRu === 'ASC', 'descending': page.sort.statusNameRu === 'DESC'}">
          Статус в ЭСФ
        </div>
      </template>

      <template #cell(bin)="data">
        <div class="v-center">
          {{ data.item.bin }}
        </div>
      </template>
      <template #cell(lmsId)="data">
        <div class="v-center">
          {{ data.item.lmsId }}
        </div>
      </template>
      <template #cell(numberAct)="data">
        <div class="v-center">
          {{ data.item.numberAct }}
        </div>
      </template>
      <template #cell(approveDate)="data">
        <div class="v-center">
          {{ formatDate(data.item.approveDate) }}
        </div>
      </template>
      <template #cell(invoiceId)="data">
        <div class="v-center">
          <div class="input-group"
               v-if="data.item.invoiceVerificationStatus !== InvoiceVerificationStatusEnum.SUCCESSFUL">
            <input v-model="data.item.invoiceId" name="inputInvoiceID" type="text" class="form-control inputInvoiceID"/>
            <button @click="onClickRefreshStatus(data.item)"
                    :disabled="data.item.invoiceId == null"
                    name="btnRefresh"
                    class="btn btn-outline-secondary">
              <font-awesome-icon icon="sync"/>
            </button>
          </div>
          <div class="input-group"
               v-if="data.item.invoiceVerificationStatus === InvoiceVerificationStatusEnum.SUCCESSFUL">
            {{ data.item.invoiceId }}
          </div>
        </div>
      </template>
      <template #cell(invoiceVerificationStatus)="data">
        <div class="v-center invoiceVerificationStatus">
          {{ getStatus(data.item.invoiceVerificationStatus) }}
          <i v-if="data.item.reason">({{data.item.reason}})</i>
        </div>
      </template>
      <template #cell(verifiedAt)="data">
        <div class="v-center">
          {{ data.item.invoiceVerificationStatus === InvoiceVerificationStatusEnum.SUCCESSFUL ? data.item.verifiedAt : '' }}
        </div>
      </template>
      <template #cell(statusNameRu)="data">
        <div class="v-center">
          {{ data.item.statusNameRu }}
        </div>
      </template>
    </b-table>
  </div>
  <div class="page-footer">
    <b-pagination
        v-model="page.partNumber"
        :total-rows="totalCount"
        :per-page="page.countInPage"
        v-on:click="reloadList"
        first-text="<<"
        last-text=">>"
        class="mt-3"
    ></b-pagination>
  </div>

  <vue-loading :active.sync="isLoading" :is-full-page="true"></vue-loading>
</template>

<script>

import {
  acceptInvoiceReconciliation,
  generateInvoiceTemplate,
  generateReport,
  getAllInvoiceReconciliations,
  getIsHaveSuccessActReconciliationsByDate,
} from "@/services/invoiceService";
import VueLoading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import {InvoiceVerificationStatusEnum} from "@/enums/InvoiceVerificationStatus";
import {saveAs} from "@/assets/FileSaver.min.js";
import Multiselect from "vue-multiselect";
import cacheService from "@/services/cacheService";
import authService from "@/services/authService";

export default {
  computed: {
    InvoiceVerificationStatusEnum() {
      return InvoiceVerificationStatusEnum
    }
  },
  components: {
    Multiselect,
    VueLoading
  },
  data() {
    return {
      showModal: false,
      isLoading: false,
      hasAccessToDownloadInvoiceTemplate: true,
      page: {
        filter: {
          year: new Date().getFullYear(),
          month: new Date().getMonth() + 1,
          bins: null,
          invoiceVerificationStatus: InvoiceVerificationStatusEnum.ALL,
          accepted: false,
          search: null,
          hideAcceptedInvoices: true,
          selectedApproveDateро: null, // Новое поле для даты
        },
        sort: {},
        partNumber: 1,
        countInPage: 10,
      },
      totalCount: 0,
      months: [
        'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
        'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
      ],
      years: Array.from({length: 11}, (v, i) => 2024 + i),
      fields: [
        {key: 'bin', label: 'БИН ДО', sortable: true},
        {key: 'lmsId', label: 'ID LMS', sortable: true},
        {key: 'numberAct', label: 'Номер акта', sortable: true},
        {key: 'signedAmount', label: 'Сумма', sortable: true},
        {key: 'approveDate', label: 'Дата утверждения акта', sortable: true},
        {key: 'invoiceId', label: 'ID счета', sortable: true},
        {key: 'invoiceVerificationStatus', label: 'Статус сверки', sortable: true},
        // {key: 'statusNameRu', label: 'Статус в ЭСФ', sortable: true},
        {key: 'verifiedAt', label: 'Время сверки ЭСФ', sortable: false}
      ],
      items: [],
      invoiceVerificationStatus: {
        ALL: 'Все',
        NONE: 'Сверка еще не проводилась',
        ACT_RECONCILIATION_NOT_FOUND: 'Акт сверки не найден для данного расчета',
        SIGNED_AMOUNT_NOT_FOUND: 'Подписанная сумма отсутствует для данного расчета',
        SIGNED_AMOUNT_MISMATCH: 'Подписанная сумма не совпадает с общей стоимостью с налогом',
        NUMBER_ACT_MISMATCH: 'Номер акта не совпадает с номером документа поставки',
        APPROVE_DATE_MISMATCH: 'Дата утверждения не совпадает с датой документа поставки или датой оборота',
        INVALID_INVOICE_ID: 'Некорректный invoiceId',
        BIC_MISMATCH: 'БИК не совпадает',
        IIK_MISMATCH: 'ИИК не совпадает',
        BIN_MISMATCH: 'БИН ОО не совпадает со справочником ФЦ',
        PREV_INVOICE_NOT_APPROVED: 'За предыдущий месяц нет корректно выставленного и проверенного ЭСФ',
        SUCCESSFUL: 'Успешно'
      },
      katoList: [],
      kindergartenHeadRoles: authService.getKindergartenHeadRoles(),
    };
  },
  methods: {
    async fetchCachedDatas() {
      this.katoList = await cacheService.useKatoStore().fetchKato();
    },
    hasAccess(...roleGroups) {
      const allRoles = roleGroups.flat();
      return authService.hasAccess(allRoles);
    },
    formattedKatoLabel(item){
      return `${item.code} | ${item.nameRu}`;
    },
    async onClickRefreshStatus(item) {
      const token = localStorage.getItem("access_token");
      if (token) {
        this.isLoading = true;
        try {
          const updatedItem = await acceptInvoiceReconciliation(token, item);
          Object.assign(item, updatedItem);
        } finally {
          this.isLoading = false;
        }
      }
    },
    async onClickGenerateReport() {
      const token = localStorage.getItem("access_token");
      if (token) {
        this.isLoading = true;
        const response = await generateReport(token, this.page);
        const blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        saveAs(blob, "document.xlsx");
        this.isLoading = false;
      }
    },

    async onClickGenerateInvoiceTemplate() {
      const token = localStorage.getItem("access_token");
      if (token) {
        this.isLoading = true;
        const response = await generateInvoiceTemplate(token, this.page);
        const blob = new Blob([response.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
        saveAs(blob, "invoiceTemplate.xlsx");
        this.isLoading = false;
      }
    },

    async reloadList() {
      const token = localStorage.getItem("access_token");
      if (token) {
        this.isLoading = true;

        const response = await getAllInvoiceReconciliations(token, this.page);
        this.items = response.list;
        this.totalCount = response.count;
        this.isLoading = false;
        this.checkActReconciliationStatus();
      }
    },

    async checkActReconciliationStatus() {
      try {
        const token = localStorage.getItem("access_token");
        this.hasAccessToDownloadInvoiceTemplate = await getIsHaveSuccessActReconciliationsByDate(token, this.page);
      } catch (error) {
        console.error("Error checking act reconciliation status:", error);
      }
    },
    onSortChanged(column) {
      this.page.sort = {
        ...this.page.sort,
        [column]: this.page.sort[column] === 'ASC' ? 'DESC' : 'ASC'
      };

      this.reloadList();
    },
    getStatus(status) {
      return this.invoiceVerificationStatus[status] || 'Неизвестный статус';
    },
    formatDate(dateTime) {
      if (!dateTime || dateTime.length === 0) {
        return null;
      }
      return dateTime.split(" ")[0];
    }
  },
  mounted() {
    this.reloadList();
    this.checkActReconciliationStatus();
    this.fetchCachedDatas();
  }
};
</script>

<style scoped>
.filters {
  .row {
    padding-top: 5px;
  }
}

.ascending {
  background-image: url("../assets/asc.svg") !important;
}

.descending {
  background-image: url("../assets/desc.svg") !important;
}

.none {
  background-image: url("../assets/none.svg");
  margin-left: 10px !important;
}

.sortable-container {
  background-position: right calc(0.75rem / 2) center;
  background-repeat: no-repeat;
  background-size: 0.65em 1em;
  vertical-align: middle !important;
  margin-right: 10px !important;
  padding-right: 15px !important;
  cursor: pointer;
}

th div {
  width: 100% !important;
  display: grid !important;
}

.v-center {
  vertical-align: middle !important;
}

.invoiceVerificationStatus {
  max-width: 400px !important;
}
</style>